import colors from './colors';
import { fontSizes } from './fontSizes';
import { fonts } from './fontStyles';
const baseStyles = (_) => ({
    display: 'inline-flex',
    alignItems: 'center',
    font: fonts.regular,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    border: `1px solid ${colors.transparent}`,
    /**
     * Adding text-decoration as a shared style so that links can
     * style themselves with button variants without issue.
     */
    textDecoration: 'none',
});
const linkStyles = (_) => ({
    height: 'fit-content',
    justifyContent: 'flex-start',
    fontSize: fontSizes.sm,
    padding: '0px',
});
const buttonStyles = (variant) => ({
    justifyContent: 'center',
    minWidth: '84px',
    borderRadius: '4px',
});
const generateStyles = (variant, styles) => {
    const { backgroundColor, color, type } = styles;
    return Object.assign(Object.assign(Object.assign(Object.assign({}, baseStyles(variant)), (type === 'button' ? buttonStyles(variant) : {})), (type === 'link' ? linkStyles(variant) : {})), { backgroundColor,
        color, '&:hover': styles['&:hover'] });
};
const getButtonStyle = (variant) => ({
    primary: Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors['link-blue'],
        color: colors.white,
        '&:hover': {
            backgroundColor: colors['hover-blue'],
        },
    })),
    secondary: Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors['blue-100'],
        color: colors['link-blue'],
        '&:hover': {
            backgroundColor: colors['blue-200'],
        },
    })),
    login: Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors['teal-600'],
        color: colors.white,
        '&:hover': {
            backgroundColor: colors['teal-700'],
        },
    })),
    disabled: Object.assign(Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors['gray-200'],
        color: colors['periwinkle-300'],
    })), { cursor: 'not-allowed' }),
    destructive: Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors['error-red'],
        color: colors.white,
        '&:hover': {
            backgroundColor: colors['hover-red'],
        },
    })),
    outline: Object.assign(Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors.white,
        color: colors['link-blue'],
        '&:hover': {
            backgroundColor: colors['gray-100'],
        },
    })), { borderColor: colors['link-blue'] }),
    icon: Object.assign({}, generateStyles(variant, {
        type: 'button',
        backgroundColor: colors.transparent,
        color: colors.transparent,
    })),
    link: Object.assign(Object.assign({}, generateStyles(variant, {
        type: 'link',
        backgroundColor: colors.transparent,
        color: colors.bluesuedeshoes,
    })), { border: 'none' }),
});
export { getButtonStyle };
//# sourceMappingURL=buttons.js.map